<template>
  <div class="">
    <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
      <div class="content">
        <section class="section--sidebar-user">
          <section class="section--title-sidebar">
            <!-- <h3>{{ this.title }}</h3> -->
          </section>
          <section class="section--content-sidebar section--content-sidebar-full-height mt-3">
            <form id="question12Form" method="POST" :action="this.action" accept-charset="UTF-8"
              enctype="multipart/form-data" class="workflow-tabs">
              <input type="hidden" name="_token" :value="csrf" />
              <input v-if="this.editing" type="hidden" name="_method" value="PUT" />

              <!--              Base name description etc-->
              <input type="hidden" class="form-control" name="questionBase[name]" v-model="name" />
              <input type="hidden" class="form-control" name="questionBase[description]" v-model="description" />
              <input type="hidden" class="form-control" name="questionBase[sorting]" v-model="sorting" />

              <ul class="nav nav-tabs" id="targetConf" role="tablist">
                <li class="nav-item" role="presentation">
                  <button class="nav-link active" id="step-1" data-toggle="tab" data-target="#baseConf" type="button"
                    role="tab" aria-controls="baseConf" aria-selected="true" @click="updateOldStep(1)">
                    {{
                      __(
                        "forms.EvaluationChart.questions.questions_setting.question12.base_settings"
                      )
                    }}
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="step-2" data-toggle="tab" data-target="#toggleEnableCompilation"
                    type="button" @click="updateOldStep(2)" role="tab" aria-controls="toggleEnableCompilation"
                    aria-selected="false">
                    {{
                      __(
                        "forms.EvaluationChart.questions.questions_setting.question12.toggleEnableCompilation"
                      )
                    }}
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="step-3" data-toggle="tab" data-target="#summaryCard" type="button"
                    @click="updateOldStep(3)" role="tab" aria-controls="summaryCard" aria-selected="false">
                    {{
                      __(
                        "forms.EvaluationChart.questions.questions_setting.question12.card_summary"
                      )
                    }}
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="step-4" data-toggle="tab" data-target="#tableKpi" type="button"
                    @click="updateOldStep(4)" role="tab" aria-controls="tableKpi" aria-selected="false">
                    {{
                      __(
                        "forms.EvaluationChart.questions.questions_setting.question12.card_table_kpi"
                      )
                    }}
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="step-5" data-toggle="tab" data-target="#assignKpi" type="button"
                    @click="updateOldStep(5)" role="tab" aria-controls="assignKpi" aria-selected="false">
                    {{
                      __(
                        "forms.EvaluationChart.questions.questions_setting.question12.card_assig_kpi"
                      )
                    }}
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="step-6" data-toggle="tab" data-target="#showAlertConsumptive"
                    type="button" @click="updateOldStep(6)" role="tab" aria-controls="assignKpi" aria-selected="false">
                    {{
                      __(
                        "forms.EvaluationChart.questions.questions_setting.question12.show_consumptive_alerts"
                      )
                    }}
                  </button>
                </li>
              </ul>
              <div class="tab-content">
                <div class="tab-pane fade show active" id="baseConf" role="tabpanel" aria-labelledby="step-1">
                  <input type="hidden" class="form-control" name="questionSettings[page]" value="1" />
                  <div class="row">
                    <div class="col-12">
                      <p class="tab-description mt-3 mb-2">
                        {{
                          __(
                            "forms.EvaluationChart.questions.questions_setting.question12.baseSettings"
                          )
                        }}
                      </p>
                    </div>
                    <div class="col-5">
                      <div class="form-group">
                        <label>{{ __("misc.title") }}</label>
                        <input type="text" class="form-control rounded" v-model="name" name="questionBase[name]" />
                      </div>

                      <div class="form-group">
                        <label>{{ __("misc.sorting") }}</label>
                        <input type="number" class="form-control rounded" v-model="sorting"
                          name="questionBase[sorting]" />
                      </div>

                      <div class="form-group">
                        <label>{{ __("misc.description") }}</label>
                        <input type="text" class="form-control rounded" v-model="description"
                          name="questionBase[description]" />
                      </div>

                      <h3 class="text-voice-title mb-2">
                        {{
                          __(
                            "forms.EvaluationChart.questions.questions_setting.question12.external_conditions.configure_creation_of_new_kpi"
                          )
                        }}
                      </h3>

                      <div class="custom-control custom-switch">
                        <input name="questionSettings[filter_by_uo]" type="checkbox" class="custom-control-input"
                          id="questionSettings[filter_by_uo]" value="1" v-model="filterByUO" />
                        <label class="custom-control-label" for="questionSettings[filter_by_uo]">{{
                          __(
                            "forms.EvaluationChart.questions.questions_setting.question12.external_conditions.filter_kpi_by_ou"
                          )
                        }}</label>
                      </div>

                      <div class="form-group" v-if="filterByUO">
                        <div>
                          <input type="checkbox" name="questionSettings[default_uo_association][]"
                            v-model="defaultUOAssociation" value="company" />
                          <label>{{ __("misc.company") }}</label>
                        </div>
                        <div v-for="row in organizationalUnits">
                          <input type="checkbox" name="questionSettings[default_uo_association][]"
                            v-model="defaultUOAssociation" :value="row.id" />
                          <label>{{ row.name }}</label>
                        </div>
                      </div>
                      <div class="form-group">
                        <h3 class="text-voice-title my-2">
                          {{ __("misc.show") }}
                          {{
                            __(
                              "forms.EvaluationChart.questions.questions_setting.question12.external_conditions.title"
                            )
                          }}
                        </h3>
                        <div class="form-group" v-for="condition in externalConditionList">
                          <input type="checkbox" name="questionSettings[externalCondition][]" :value="condition.id"
                            v-model="externalCondition" />
                          <label>{{ condition.name }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-5 offset-1">
                      <div class="form-group">
                        <label>Piano di incentivazione variabile</label>
                        <select name="questionSettings[kpi_incentive_plan_id]" class="form-control rounded" required
                          v-model="kpi_incentive_plan_id">
                          <option>---</option>
                          <option v-for="(name, index) in list_kpi_incentive_plan" :value="index">
                            {{ name }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>
                          {{
                            __(
                              "forms.EvaluationChart.questions.questions_setting.question12.whoUpdateConsumptive"
                            )
                          }}:
                        </label>
                        <select class="form-control rounded" name="questionSettings[who_update_consumptive]"
                          v-model="whoUpdateConsumptive">
                          <option value="owner">
                            {{
                              __(
                                "forms.EvaluationChart.questions.questions_setting.question12.whoUpdateConsumptiveOwner"
                              )
                            }}
                          </option>
                          <option value="anyone">
                            {{
                              __(
                                "forms.EvaluationChart.questions.questions_setting.question12.whoUpdateConsumptiveAnyone"
                              )
                            }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>
                          {{
                            __(
                              "forms.EvaluationChart.questions.questions_setting.question12.whoUpdateKpi"
                            )
                          }}:
                        </label>
                        <select class="form-control rounded" name="questionSettings[who_update_kpi]"
                          v-model="whoUpdateKpi">
                          <option value="owner">
                            {{
                              __(
                                "forms.EvaluationChart.questions.questions_setting.question12.whoUpdateConsumptiveOwner"
                              )
                            }}
                          </option>
                          <option value="anyone">
                            {{
                              __(
                                "forms.EvaluationChart.questions.questions_setting.question12.whoUpdateConsumptiveAnyone"
                              )
                            }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>
                          {{
                            __(
                              "forms.Question.Elements.question12.shared_kpi_beneficiary_filter"
                            )
                          }}:
                        </label>
                        <select class="form-control rounded" name="questionSettings[shared_kpi_beneficiary_filter]"
                          v-model="sharedKpiBeneficiaryFilter">
                          <option value="1">
                            {{
                              __(
                                "forms.EvaluationChart.questions.questions_setting.question12.beneficiary"
                              )
                            }}
                          </option>
                          <option value="0">
                            {{
                              __(
                                "forms.EvaluationChart.questions.questions_setting.question12.whoUpdateConsumptiveAnyone"
                              )
                            }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>
                          {{
                            __(
                              "forms.EvaluationChart.questions.questions_setting.question12.globalRatingMethod"
                            )
                          }}
                        </label>
                        <select name="questionSettings[global_rating_prize]" class="form-control rounded" required
                          v-model="globalRatingPrize">
                          <option value="avg">
                            {{
                              __(
                                "forms.EvaluationChart.questions.questions_setting.question12.globalRatingMethodAvg"
                              )
                            }}
                          </option>
                          <option value="avg_weighted">
                            {{
                              __(
                                "forms.EvaluationChart.questions.questions_setting.question12.globalRatingMethodAvgWeighted"
                              )
                            }}
                          </option>
                        </select>
                      </div>

                      <div class="custom-control custom-switch">
                        <input name="questionSettings[show_pie_graph]" type="checkbox" class="custom-control-input"
                          id="questionSettings[show_pie_graph]" value="1" v-model="showPieGraph" />
                        <label class="custom-control-label" for="questionSettings[show_pie_graph]">{{
                          __(
                            "forms.EvaluationChart.questions.questions_setting.question12.showPieChart"
                          )
                        }}</label>
                      </div>

                      <div class="custom-control custom-switch">
                        <input name="questionSettings[show_line_chart]" type="checkbox" class="custom-control-input"
                          id="questionSettings[show_line_chart]" value="1" v-model="showLineChart" />
                        <label class="custom-control-label" for="questionSettings[show_line_chart]">{{
                          __(
                            "forms.EvaluationChart.questions.questions_setting.question12.showLineChart"
                          )
                        }}</label>
                      </div>

                      <div class="form-group">
                        <h3 class="text-voice-title mb-2">
                          {{ __("misc.show") }}
                          {{ __("views.KpiIndicators.title") }}
                        </h3>
                        <div class="alert alert-warning">
                          {{
                            __("forms.EvaluationChart.questions.questions_setting.question12.alert_messages.share_kpi_config_info")
                          }}
                        </div>

                        <div class="form-group" v-for="indicator in indicators" :key="indicator.slug">
                          <div class="custom-control custom-switch">
                            <input name="questionSettings[showIndicators][]" type="checkbox"
                              class="custom-control-input" :id="indicator.slug" :value="indicator.slug"
                              v-model="showIndicators[indicator.slug]" />
                            <label class="custom-control-label" :for="indicator.slug">
                              {{ indicator.name }}
                              <span v-if="indicator.is_shared_indicator">
                                <i class="fa-solid fa-share-nodes"></i>
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mt-3 text-right" v-if="can_write">
                    <button class="btn btn-next" @click="goToStep(2, false)" type="button">
                      {{ __("misc.next") }}
                    </button>
                  </div>
                </div>
                <div class="tab-pane fade" id="toggleEnableCompilation" role="tabpanel"
                  aria-labelledby="toggleEnableCompilation">
                  <div class="row">
                    <div class="col-12">
                      <p class="tab-description my-4">
                        {{
                          __(
                            "forms.EvaluationChart.questions.questions_setting.question12.toggleEnableCompilation"
                          )
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <div class="col-12">
                      <div class="form-group">
                        <div class="custom-control custom-switch">
                          <input name="questionSettings[can_enable_disable_compilation]" type="checkbox"
                            class="custom-control-input" id="questionSettings[can_enable_disable_compilation]" value="1"
                            v-model="can_enable_disable_compilation" />
                          <label class="custom-control-label" for="questionSettings[can_enable_disable_compilation]">
                            {{
                              __(
                                "forms.EvaluationChart.questions.questions_setting.question12.enableCompilationChoose"
                              )
                            }}
                          </label>
                        </div>
                      </div>
                    </div>
                    <hr />

                    <div class="col-12" v-for="language in languages">
                      <div class="form-group">
                        <div class="user-setting-utility row">
                          <div class="col-1">
                            <img :src="language.iconUrl" height="24px" width="24px" alt="" />
                          </div>
                          <div class="col-11">
                            <input type="text" class="form-control" :name="'questionSettings[enable_disable_compilation_message][' +
                              language.slug +
                              ']'
                              " v-model="enable_disable_compilation_message[
                                language.slug
                              ]
                                " />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 mt-3 text-right" v-if="can_write">
                      <button type="button" class="btn btn-back" @click="goToStep(1, false)">
                        {{ __("misc.prev") }}
                      </button>
                      <button type="button" class="btn btn-next" @click="goToStep(3, false)">
                        {{ __("misc.next") }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="summaryCard" role="tabpanel" aria-labelledby="summaryCard">
                  <div class="row">
                    <div class="col-12 align-items-center">
                      <p class="tab-description text-center my-4">
                        {{
                          __(
                            "forms.EvaluationChart.questions.questions_setting.question12.summary.card_summary_info"
                          )
                        }}
                      </p>
                    </div>
                    <div class="col-12">
                      <div class="row justify-content-center">
                        <div class="col-4">
                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_sum_percent_reach_for_weight]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_sum_percent_reach_for_weight]"
                                value="1" v-model="showSumPercentForWeight" />
                              <label class="custom-control-label"
                                for="questionSettings[show_sum_percent_reach_for_weight]">{{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.summary.show_sum_percent_reach_for_weight"
                                  )
                                }}</label>
                            </div>
                          </div>
                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_prize_assigned]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_prize_assigned]" value="1"
                                v-model="showPrizeAssigned" />
                              <label class="custom-control-label" for="questionSettings[show_prize_assigned]">{{
                                __(
                                  "forms.EvaluationChart.questions.questions_setting.question12.summary.sumPrize"
                                )
                              }}</label>
                            </div>
                          </div>
                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_prize_reached]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_prize_reached]" value="1"
                                v-model="showPrizeReached" />
                              <label class="custom-control-label" for="questionSettings[show_prize_reached]">{{
                                __(
                                  "forms.EvaluationChart.questions.questions_setting.question12.summary.sumRepartedPrize"
                                )
                              }}</label>
                            </div>
                          </div>
                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_prize_final]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_prize_final]" value="1"
                                v-model="showPrizeFinal" />
                              <label class="custom-control-label" for="questionSettings[show_prize_final]">{{
                                __(
                                  "forms.EvaluationChart.questions.questions_setting.question12.summary.sumPrizeFinal"
                                )
                              }}</label>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_ral]" type="checkbox" class="custom-control-input"
                                id="questionSettings[show_ral]" value="1" v-model="showRal" />
                              <label class="custom-control-label" for="questionSettings[show_ral]">{{
                                __("forms.KPIIncentivePlan.ral_pay_item")
                                }}</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_target_bonus]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_target_bonus]" value="1"
                                v-model="showTargetBonus" />
                              <label class="custom-control-label" for="questionSettings[show_target_bonus]">{{
                                __("forms.KPIPeople.percentage_prize")
                                }}</label>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_target_euro]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_target_euro]" value="1"
                                v-model="showTargetEuro" />
                              <label class="custom-control-label" for="questionSettings[show_target_euro]">{{
                                __("forms.KPIPeople.target_euro") }}</label>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[read_target]" type="checkbox" class="custom-control-input"
                                id="questionSettings[read_target]" value="1" v-model="readTarget" />
                              <label class="custom-control-label" for="questionSettings[read_target]">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.readOnlyTargetBonusEuro"
                                  )
                                }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 mt-3 text-right" v-if="can_write">
                      <button type="button" class="btn btn-back" @click="goToStep(2, false)">
                        {{ __("misc.prev") }}
                      </button>
                      <button type="button" class="btn btn-next" @click="goToStep(4, false)">
                        {{ __("misc.next") }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="tableKpi" role="tabpanel" aria-labelledby="tableKpi">
                  <div class="row">
                    <div class="col-12">
                      <p class="tab-description text-center my-4">
                        {{
                          __(
                            "forms.EvaluationChart.questions.questions_setting.question12.selectColumn"
                          )
                        }}
                      </p>
                    </div>
                    <div class="col-12">
                      <div class="row justify-content-center">
                        <div class="col-4">
                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_unit_measure]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_unit_measure]" value="1"
                                v-model="showUnitMeasure" />
                              <label class="custom-control-label" for="questionSettings[show_unit_measure]">{{
                                __(
                                  "forms.EvaluationChart.questions.questions_setting.question12.showUnitMeasures"
                                )
                              }}</label>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_measures_and_formulas]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_measures_and_formulas]" value="1"
                                v-model="showMeasuresAndFormulas" />
                              <label class="custom-control-label" for="questionSettings[show_measures_and_formulas]">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.showMeasuresAndFormula"
                                  )
                                }}
                              </label>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_typology]" type="checkbox" class="custom-control-input"
                                id="questionSettings[show_typology]" value="1" v-model="showTypology" />
                              <label class="custom-control-label" for="questionSettings[show_typology]">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.showTypology"
                                  )
                                }}
                              </label>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_target_100]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_target_100]" value="1"
                                v-model="showTarget100" />
                              <label class="custom-control-label" for="questionSettings[show_target_100]">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.showTarget100"
                                  )
                                }}
                              </label>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_target_min_max]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_target_min_max]" value="1"
                                v-model="showTargetMinMax" />
                              <label class="custom-control-label" for="questionSettings[show_target_min_max]">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.showTargetMinMax"
                                  )
                                }}
                              </label>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_prizes_min_max]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_prizes_min_max]" value="1"
                                v-model="showPrizesMinMax" />
                              <label class="custom-control-label" for="questionSettings[show_prizes_min_max]">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.showPrizesMinMax"
                                  )
                                }}
                              </label>
                            </div>
                          </div>
                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_kpi_description_in_chart]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_kpi_description_in_chart]"
                                value="1" v-model="showKpiDescriptionInChart" />
                              <label class="custom-control-label" for="questionSettings[show_kpi_description_in_chart]">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.showKpiDescriptionInChart"
                                  )
                                }}
                              </label>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_kpi_esg_in_chart]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_kpi_esg_in_chart]" value="1"
                                v-model="showEsg">
                              <label class="custom-control-label" for="questionSettings[show_kpi_esg_in_chart]">
                                {{
                                  __("forms.EvaluationChart.questions.questions_setting.question12.showEsg")
                                }}
                              </label>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_kpi_classification_in_chart]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_kpi_classification_in_chart]"
                                value="1" v-model="showClassification">
                              <label class="custom-control-label"
                                for="questionSettings[show_kpi_classification_in_chart]">
                                {{
                                __("forms.EvaluationChart.questions.questions_setting.question12.showClassification")
                                }}
                              </label>
                            </div>
                          </div>

                        </div>
                        <div class="col-4">
                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_percent_reach_for_weight]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_percent_reach_for_weight]"
                                value="1" v-model="showPercentReachForWeight" />
                              <label class="custom-control-label"
                                for="questionSettings[show_percent_reach_for_weight]">{{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.tableKPI.percent_reach_for_weight"
                                  )
                                }}</label>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_performance_percent]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_performance_percent]" value="1"
                                v-model="showPerformancePercent" />
                              <label class="custom-control-label" for="questionSettings[show_performance_percent]">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.showPercentPerformance"
                                  )
                                }}
                              </label>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_reach_percent]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_reach_percent]" value="1"
                                v-model="showReachPercent" />
                              <label class="custom-control-label" for="questionSettings[show_reach_percent]">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.showReachPercent"
                                  )
                                }}
                              </label>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_segmentation_info_in_description_modal]"
                                type="checkbox" class="custom-control-input"
                                id="questionSettings[show_segmentation_info_in_description_modal]" value="1" v-model="show_segmentation_info_in_description_modal
                                  " />
                              <label class="custom-control-label"
                                for="questionSettings[show_segmentation_info_in_description_modal]">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.showSegmentationInfo"
                                  )
                                }}
                              </label>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_bonus_target]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_bonus_target]" value="1"
                                v-model="bonusTarget" />
                              <label class="custom-control-label" for="questionSettings[show_bonus_target]">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.showBonusTarget"
                                  )
                                }}
                              </label>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_bonus_weight]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_bonus_weight]" value="1"
                                v-model="bonusWeight" />
                              <label class="custom-control-label" for="questionSettings[show_bonus_weight]">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.showBonusWeight"
                                  )
                                }}
                              </label>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_bonus_rep]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_bonus_rep]" value="1"
                                v-model="bonusRep" />
                              <label class="custom-control-label" for="questionSettings[show_bonus_rep]">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.showBonusRep"
                                  )
                                }}
                              </label>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[gross_bonus_sum_achieved]" type="checkbox"
                                class="custom-control-input" id="questionSettings[gross_bonus_sum_achieved]" value="1"
                                v-model="grossBonusSumAchieved" />
                              <label class="custom-control-label" for="questionSettings[gross_bonus_sum_achieved]">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.showGrossBonusSumAchieved"
                                  )
                                }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 mt-3 text-right" v-if="can_write">
                      <button type="button" class="btn btn-back" @click="goToStep(3, false)">
                        {{ __("misc.prev") }}
                      </button>
                      <button type="button" class="btn btn-next" @click="goToStep(5, false)">
                        {{ __("misc.next") }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="assignKpi" role="tabpanel" aria-labelledby="assignKpi">
                  <div class="row">
                    <div class="col-12">
                      <p class="tab-description my-3">
                        {{
                          __(
                            "forms.EvaluationChart.questions.questions_setting.question12.generalSettings"
                          )
                        }}
                      </p>
                    </div>
                    <div class="col-12">
                      <div class="row">
                        <div class="col-6 col-md-3">
                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[show_prize_value]" type="checkbox"
                                class="custom-control-input" id="questionSettings[show_prize_value]" value="1"
                                v-model="show_prize_value" />
                              <label class="custom-control-label" for="questionSettings[show_prize_value]">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.showPrizeValue"
                                  )
                                }}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="col-6 col-md-3">
                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[approve_kpi]" type="checkbox" class="custom-control-input"
                                id="questionSettings[approve_kpi]" value="1" v-model="approve_kpi" />
                              <label class="custom-control-label" for="questionSettings[approve_kpi]">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.approveKPI"
                                  )
                                }}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="col-6 col-md-3">
                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[enable_change_target]" type="checkbox"
                                class="custom-control-input" id="questionSettings[enable_change_target]" value="1"
                                v-model="enable_change_target" />
                              <label class="custom-control-label" for="questionSettings[enable_change_target]">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.enableChangeTarget"
                                  )
                                }}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="col-6 col-md-3">
                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[checkbox_number_goals]" type="checkbox"
                                class="custom-control-input" id="questionSettings[checkbox_number_goals]" value="1"
                                v-model="checkbox_number_goals" />
                              <label class="custom-control-label" for="questionSettings[checkbox_number_goals]">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.checkNumberGoals"
                                  )
                                }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input name="questionSettings[limit_by_indicator]" type="checkbox"
                                class="custom-control-input" id="questionSettings[limit_by_indicator]" value="1"
                                v-model="limitByIndicator" />
                              <label class="custom-control-label" for="questionSettings[limit_by_indicator]">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.limitByIndicator"
                                  )
                                }}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="row" v-if="limitByIndicator">
                            <div class="col-3" v-for="(indicator, i) in indicators"
                              v-if="showIndicators[indicator.slug]" :key="i">
                              <label class="text-voice-title" mt-1>{{
                                indicator.name
                              }}</label>
                              <div class="row">
                                <div class="col-6">
                                  <label>Minimo</label>
                                  <input class="form-control rounded" type="number" min="0" :name="'questionSettings[limits][' +
                                    indicator.slug +
                                    '][min]'
                                    " v-model="limits[indicator.slug]['min']" />
                                </div>
                                <div class="col-6">
                                  <label>Massimo</label>
                                  <input class="form-control rounded" type="number" min="0" :name="'questionSettings[limits][' +
                                    indicator.slug +
                                    '][max]'
                                    " v-model="limits[indicator.slug]['max']" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 mt-4">
                      <div class="row">
                        <div class="col-12">
                          <p class="tab-description">
                            {{
                              __(
                                "forms.EvaluationChart.questions.questions_setting.question12.createNewKpi"
                              )
                            }}
                          </p>
                        </div>
                      </div>
                      <hr>
                      <div class="row">
                        <div class="col-6">
                          <div class="form-group">
                            <label>
                              {{
                                __(
                                  "forms.EvaluationChart.questions.questions_setting.question12.defaultSegmentationType"
                                )
                              }}
                            </label>
                            <select name="questionSettings[default_segmentation_type]" class="form-control rounded"
                              required v-model="default_segmentation_type">
                              <option value="0">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.defaultSegmentationTypeChoose"
                                  )
                                }}
                              </option>
                              <option value="line">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.defaultSegmentationTypeLine"
                                  )
                                }}
                              </option>
                              <option value="step">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.defaultSegmentationTypeStep"
                                  )
                                }}
                              </option>
                            </select>
                          </div>
                          <div class="form-group">
                            <label>{{
                              __(
                                "forms.EvaluationChart.questions.questions_setting.question12.segmentationMode"
                              )
                            }}</label>
                            <select name="questionSettings[segmentation_mode]" class="form-control rounded" required
                              v-model="segmentation_mode">
                              <option value="-1">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.segmentationModeCreate"
                                  )
                                }}
                              </option>
                              <option value="0">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.segmentationModeChoose"
                                  )
                                }}
                              </option>
                              <option value="1">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.segmentationModeStatic"
                                  )
                                }}
                              </option>
                            </select>
                          </div>

                          <div class="form-group" v-if="segmentation_mode == -1">
                            <label>{{
                              __(
                                "forms.EvaluationChart.questions.questions_setting.question12.chooserKpiSegmentGroup"
                              )
                            }}</label>
                            <select name="questionSettings[kpi_segment_group_id]" v-model="kpi_segment_group_id"
                              class="form-control rounded" required>
                              <option value="">---</option>
                              <option v-for="kpiSegmentGroup in kpiSegmentGroups" :key="kpiSegmentGroup.id"
                                :value="kpiSegmentGroup.id">
                                {{ kpiSegmentGroup.name }}
                              </option>
                            </select>
                          </div>
                          <div class="form-group" v-if="segmentation_mode == 1">
                            <label>{{
                              __(
                                "forms.EvaluationChart.questions.questions_setting.question12.chooseKpiSegmentStatic"
                              )
                            }}</label>
                            <select name="questionSettings[segmentation_id]" class="form-control rounded" required
                              v-model="segmentation_id">
                              <option v-for="segmentation in segmentations" :value="segmentation.id">
                                {{ segmentation.name }}
                              </option>
                            </select>
                            <label>
                              {{
                                __("forms.KPISegments.direction_segmentation")
                              }}
                            </label>
                            <select name="questionSettings[segmentation_direction]" class="form-control rounded"
                              required v-model="segmentation_direction">
                              <option value="increment">
                                {{
                                  __(
                                    "forms.KPISegments.direction_segmentation_increment"
                                  )
                                }}
                              </option>
                              <option value="decrement">
                                {{
                                  __(
                                    "forms.KPISegments.direction_segmentation_decrement"
                                  )
                                }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="row">
                            <div class="col-12">
                              <div v-if="segmentation_mode == -1">
                                <div class="form-group">
                                  <label>{{
                                    __(
                                      "forms.EvaluationChart.questions.questions_setting.question12.chooseSegmentCalculation"
                                    )
                                  }}</label>
                                  <select name="questionSettings[segmentation_calculation]" class="form-control rounded"
                                    required v-model="segmentation_calculation">
                                    <option value="-1">
                                      {{
                                        __(
                                          "forms.EvaluationChart.questions.questions_setting.question12.chooseSegmentInChart"
                                        )
                                      }}
                                    </option>
                                    <option value="0">
                                      {{
                                        __(
                                          "forms.KPISegments.manual_performance"
                                        )
                                      }}
                                    </option>
                                    <option value="1">
                                      {{
                                        __(
                                          "forms.KPISegments.automatic_performance"
                                        )
                                      }}
                                    </option>
                                  </select>
                                </div>

                                <div class="form-group">
                                  <input type="checkbox" :name="'questionSettings[enable_segmentation_standard]'"
                                    v-model="enable_segmentation_standard" />
                                  <label>
                                    {{
                                      __(
                                        "forms.EvaluationChart.questions.questions_setting.question12.canClone"
                                      )
                                    }}
                                  </label>
                                </div>
                              </div>
                              <div class="form-group">
                                <label>
                                  {{ __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.showFlagKpiRequireFileOnConsumptive")
                                  }}
                                </label>
                                <select class="form-control" name="questionSettings[kpi_require_file_on_consumptive]"
                                  v-model="defaultKpiRequireFileOnConsumptive">
                                  <option value='kpi_require_file_on_consumptive_default_false'>
                                    <label>
                                      {{
                                        __("forms.EvaluationChart.questions.questions_setting.question12.defaultKpiRequireFileOnConsumptive_not_required")
                                      }}
                                    </label>
                                  </option>
                                  <option value='kpi_require_file_on_consumptive_default_true'>
                                    <label>
                                      {{
                                        __("forms.EvaluationChart.questions.questions_setting.question12.defaultKpiRequireFileOnConsumptive_required")
                                      }}
                                    </label>
                                  </option>
                                  <option value='kpi_require_file_on_consumptive_choose_on_chart'>
                                    <label>
                                      {{
                                        __("forms.EvaluationChart.questions.questions_setting.question12.kpi_require_file_on_consumptive_choose_on_chart")
                                      }}
                                    </label>
                                  </option>
                                </select>
                              </div>
                              <div class="form-group">
                                <input type="checkbox" :name="'questionSettings[show_not_standard_segmentation]'"
                                  value="1" v-model="show_not_standard_segmentation" />
                                <label>
                                  {{
                                    __(
                                      "forms.EvaluationChart.questions.questions_setting.question12.showNotStandardSegmentation"
                                    )
                                  }}
                                </label>
                              </div>
                              <div class="form-group">
                                <input type="checkbox" :name="'questionSettings[show_all_standard_segmentations]'"
                                  v-model="show_all_standard_segmentations" />
                                <label>
                                  {{
                                    __(
                                      "forms.EvaluationChart.questions.questions_setting.question12.showStandardSegmentation"
                                    )
                                  }}
                                </label>
                              </div>
                              <div v-if="!show_all_standard_segmentations">
                                <label>
                                  {{
                                    __(
                                      "forms.EvaluationChart.questions.questions_setting.question12.chooseStandardSegmentation"
                                    )
                                  }}
                                </label>
                                <div v-for="row in allStandardSegmentations">
                                  <input type="checkbox" :value="row.id"
                                    :name="'questionSettings[selected_standard_segmentations][]'"
                                    v-model="selected_standard_segmentations" />
                                  <label>{{ row.name }}</label>
                                </div>
                              </div>

                              <div class="form-group">
                                <input name="questionSettings[show_percent_performance_on_create_kpi]" type="checkbox"
                                  value="1" v-model="showPercentPerformanceOnCreateKpi" />
                                <label>
                                  {{
                                    __(
                                      "forms.EvaluationChart.questions.questions_setting.question12.showPercentPerformanceOnCreateKpi"
                                    )
                                  }}
                                </label>
                              </div>
                              <div class="form-group">
                                <input name="questionSettings[show_percent_reaching_on_create_kpi]" type="checkbox"
                                  value="1" v-model="showPercentReachingOnCreateKpi" />
                                <label>
                                  {{
                                    __(
                                      "forms.EvaluationChart.questions.questions_setting.question12.showPercentReachingOnCreateKpi"
                                    )
                                  }}
                                </label>
                              </div>
                              <div class="form-group">
                                <input name="questionSettings[required_classification_on_create_kpi]" type="checkbox"
                                  value="1" v-model="requiredClassificationOnCreateKpi" />
                                <label>
                                  {{
                                    __(
                                      "forms.EvaluationChart.questions.questions_setting.question12.requiredClassificationOnCreateKpi"
                                    )
                                  }}
                                </label>
                              </div>
                              <div class="form-group">
                                <input name="questionSettings[show_classification_on_create_kpi]" type="checkbox"
                                  value="1" v-model="showClassificationOnCreateKpi" />
                                <label>
                                  {{
                                    __(
                                      "forms.EvaluationChart.questions.questions_setting.question12.showClassificationOnCreateKpi"
                                    )
                                  }}
                                </label>
                              </div>
                              <div class="form-group">
                                <input name="questionSettings[show_esg_on_create_kpi]" type="checkbox" value="1"
                                  v-model="showEsgOnCreateKpi">
                                <label>
                                  {{
                                    __("forms.EvaluationChart.questions.questions_setting.question12.showEsgOnCreateKpi")
                                  }}
                                </label>
                              </div>
                              <div class="form-group">
                                <input name="questionSettings[show_categories_on_create_kpi]" type="checkbox" value="1"
                                  v-model="showCategoriesOnCreateKpi">
                                <label>
                                  {{
                                    __("forms.EvaluationChart.questions.questions_setting.question12.showCategoriesOnCreateKpi")
                                  }}
                                </label>
                              </div>
                              <div class="form-group">
                                <input name="questionSettings[show_classification_on_create_kpi]" type="checkbox"
                                  value="1" v-model="showClassificationOnCreateKpi">
                                <label>
                                  {{
                                  __("forms.EvaluationChart.questions.questions_setting.question12.showClassificationOnCreateKpi")
                                  }}
                                </label>
                              </div>
                              <div class="form-group">
                                <input name="questionSettings[show_esg_on_create_kpi]" type="checkbox" value="1"
                                  v-model="showEsgOnCreateKpi">
                                <label>
                                  {{
                                  __("forms.EvaluationChart.questions.questions_setting.question12.showEsgOnCreateKpi")
                                  }}
                                </label>
                              </div>
                              <div class="form-group">
                                <input name="questionSettings[show_categories_on_create_kpi]" type="checkbox" value="1"
                                  v-model="showCategoriesOnCreateKpi">
                                <label>
                                  {{
                                    __("forms.EvaluationChart.questions.questions_setting.question12.showCategoriesOnCreateKpi")
                                  }}
                                </label>
                              </div>
                              <div class="form-group">
                                <input name="questionSettings[show_classification_on_create_kpi]" type="checkbox"
                                  value="1" v-model="showClassificationOnCreateKpi">
                                <label>
                                  {{
                                  __("forms.EvaluationChart.questions.questions_setting.question12.showClassificationOnCreateKpi")
                                  }}
                                </label>
                              </div>
                              <div class="form-group">
                                <input name="questionSettings[show_esg_on_create_kpi]" type="checkbox"
                                  value="1" v-model="showEsgOnCreateKpi">
                                <label>
                                  {{
                                    __("forms.EvaluationChart.questions.questions_setting.question12.showEsgOnCreateKpi")
                                  }}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="col-12">
                      <div class="form-group">
                        <label>{{
                          __(
                            "forms.EvaluationChart.questions.questions_setting.question12.prizeMode"
                          )
                        }}</label>
                        <select name="questionSettings[prize_mode]" class="form-control rounded w-25" required
                          v-model="kpi_prize_mode">
                          <option>---</option>
                          <option value="ral_percentage">
                            {{ __("forms.KPIS.ral_percentage") }}
                          </option>
                          <option value="fixed_amount">
                            {{ __("forms.KPIPeople.fixed_amount") }}
                          </option>
                          <option value="weight_percentage">
                            {{
                              __(
                                "forms.EvaluationChart.questions.questions_setting.question12.prizeNames.weight_percentage"
                              )
                            }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>{{
                          __(
                            "forms.EvaluationChart.questions.questions_setting.question12.filterSegmentationTypology"
                          )
                        }}</label>
                        <div class="form-group">
                          <input type="checkbox" name="questionSettings[filter_segmentation_typology][]" value="number"
                            v-model="filterSegmentationTypology" />
                          <label>{{
                            __("forms.KPISegments.number_segmentation")
                          }}</label>
                        </div>
                        <div class="form-group">
                          <input type="checkbox" name="questionSettings[filter_segmentation_typology][]" value="date"
                            v-model="filterSegmentationTypology" />
                          <label>{{
                            __("forms.KPISegments.date_segmentation")
                          }}</label>
                        </div>
                        <div class="form-group">
                          <input type="checkbox" name="questionSettings[filter_segmentation_typology][]" value="text"
                            v-model="filterSegmentationTypology" />
                          <label>{{
                            __("forms.KPISegments.text_segmentation")
                          }}</label>
                        </div>
                      </div>
                      <hr />

                      <div>
                        <div v-if="checkbox_number_goals">
                          <div class="form-group">
                            <input type="checkbox" :name="'questionSettings[block_edit_reparted_prize]'"
                              v-model="block_edit_reparted_prize" />
                            <label>{{
                              __(
                                "forms.EvaluationChart.questions.questions_setting.question12.block_edit_reparted_prize"
                              )
                            }}</label>
                          </div>
                          <div class="form-group">
                            <div class="d-flex align-items-center my-3">
                              <p class="tab-description">
                                {{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.staticGoals"
                                  )
                                }}
                              </p>
                              <button class="btn btn--blue ml-3" type="button" @click="addStaticGoal()">
                                <label class="text-white">{{
                                  __(
                                    "forms.EvaluationChart.questions.questions_setting.question12.addGoal"
                                  )
                                }}</label>
                              </button>
                            </div>
                            <table class="table">
                              <thead>
                                <tr>
                                  <th style="width: 10%" scope="col"></th>
                                  <th scope="col">
                                    {{
                                      __(
                                        "forms.EvaluationChart.questions.questions_setting.question12.percentPerformance"
                                      )
                                    }}
                                  </th>
                                  <th scope="col">
                                    {{
                                      __(
                                        "forms.EvaluationChart.questions.questions_setting.question12.repPrizePerc"
                                      )
                                    }}
                                  </th>
                                  <th scope="col">
                                    {{
                                      __(
                                        "forms.EvaluationChart.questions.questions_setting.question12.note"
                                      )
                                    }}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(
                                    row_goal, index
                                  ) in static_goals_array">
                                  <td style="width: 10%">
                                    <button
                                      class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove"
                                      type="button" @click="rmGoalRow(index)">
                                      <i class="fas fa-trash"></i>
                                    </button>
                                  </td>
                                  <td>
                                    <input :name="'questionSettings[static_goals_array][' +
                                      index +
                                      '][treshold]'
                                      " type="number" class="form-control rounded" step="0.01"
                                      v-model="row_goal.treshold" />
                                  </td>
                                  <td>
                                    <input :name="'questionSettings[static_goals_array][' +
                                      index +
                                      '][percentage]'
                                      " type="number" class="form-control rounded" step="0.01"
                                      v-model="row_goal.percentage" />
                                  </td>
                                  <td>
                                    <input :name="'questionSettings[static_goals_array][' +
                                      index +
                                      '][note]'
                                      " type="text" class="form-control rounded" v-model="row_goal.note" />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mt-3 text-right" v-if="can_write">
                    <button type="button" class="btn btn-back" @click="goToStep(5, false)">
                      {{ __("misc.prev") }}
                    </button>
                    <button type="button" class="btn btn-next" @click="goToStep(6, false)">
                      {{ __("misc.next") }}
                    </button>
                  </div>
                </div>
                <div class="tab-pane fade" id="showAlertConsumptive" role="tabpanel"
                  aria-labelledby="showAlertConsumptive">
                  <div class="row">
                    <div class="col-12">
                      <p class="tab-description my-3">
                        {{
                          __(
                            "forms.EvaluationChart.questions.questions_setting.question12.show_consumptive_alerts"
                          )
                        }}
                      </p>
                    </div>
                    <div class="col-12">
                      <div class="form-group">
                        <div>
                          <label class="" for="questionSettings[alert_block_wrong_consumptive_method_below_min_goal]">
                            {{
                              __(
                                "forms.EvaluationChart.questions.questions_setting.question12.alert_block_wrong_consumptive_method_below_min_goal"
                              )
                            }}
                          </label>
                          <select name="questionSettings[alert_block_wrong_consumptive_method_below_min_goal]"
                            class="form-control"
                            id="questionSettings[alert_block_wrong_consumptive_method_below_min_goal]" v-model="alertBlockWrongConsumptiveMethodBelowMinGoal
                              ">
                            <option value="no_action_when_consumptive_is_out_of_bound">
                              {{
                                __(
                                  "forms.EvaluationChart.questions.questions_setting.question12.no_action_when_consumptive_is_out_of_bound"
                                )
                              }}
                            </option>
                            <option value="show_alert_consumptive_below_min_goal">
                              {{
                                __(
                                  "forms.EvaluationChart.questions.questions_setting.question12.show_alert_consumptive_below_min_goal"
                                )
                              }}
                            </option>
                            <option value="show_and_block_consumptive_below_min_goal">
                              {{
                                __(
                                  "forms.EvaluationChart.questions.questions_setting.question12.show_and_block_consumptive_below_min_goal"
                                )
                              }}
                            </option>
                          </select>
                        </div>
                        <div class="col-12" v-for="language in languages">
                          <div class="form-group">
                            <div class="user-setting-utility row">
                              <div class="col-1">
                                <img :src="language.iconUrl" height="24px" width="24px" alt="" />
                              </div>
                              <div class="col-11">
                                <input type="text" class="form-control" :name="'questionSettings[message_consumptive_below_min_goal][' +
                                  language.slug +
                                  ']'
                                  " v-model="messageAlertConsumptiveBelowMinGoal[
                                    language.slug
                                  ]
                                    " />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div>
                          <label class="" for="questionSettings[alert_block_wrong_consumptive_method_above_max_goal]">
                            {{
                              __(
                                "forms.EvaluationChart.questions.questions_setting.question12.alert_block_wrong_consumptive_method_above_max_goal"
                              )
                            }}
                          </label>

                          <select name="questionSettings[alert_block_wrong_consumptive_method_above_max_goal]"
                            class="form-control"
                            id="questionSettings[alert_block_wrong_consumptive_method_above_max_goal]" v-model="alertBlockWrongConsumptiveMethodAboveMaxGoal
                              ">
                            <option value="no_action_when_consumptive_is_out_of_bound">
                              {{
                                __(
                                  "forms.EvaluationChart.questions.questions_setting.question12.no_action_when_consumptive_is_out_of_bound"
                                )
                              }}
                            </option>
                            <option value="show_alert_consumptive_above_max_goal">
                              {{
                                __(
                                  "forms.EvaluationChart.questions.questions_setting.question12.show_alert_consumptive_above_max_goal"
                                )
                              }}
                            </option>
                            <option value="show_and_block_consumptive_above_max_goal">
                              {{
                                __(
                                  "forms.EvaluationChart.questions.questions_setting.question12.show_and_block_consumptive_above_max_goal"
                                )
                              }}
                            </option>
                          </select>
                        </div>

                        <div class="col-12" v-for="language in languages">
                          <div class="form-group">
                            <div class="user-setting-utility row">
                              <div class="col-1">
                                <img :src="language.iconUrl" height="24px" width="24px" alt="" />
                              </div>
                              <div class="col-11">
                                <input type="text" class="form-control" :name="'questionSettings[message_consumptive_above_max_goal][' +
                                  language.slug +
                                  ']'
                                  " v-model="messageAlertConsumptiveAboveMaxGoal[
                                    language.slug
                                  ]
                                    " />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div class="col-12 mt-3 text-right" v-if="can_write">
                        <button type="button" class="btn btn-back" @click="goToStep(5, false)">
                          {{ __("misc.prev") }}
                        </button>
                        <button type="button" class="btn btn-next" @click="goToStep(6, true)">
                          {{ __("misc.save") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </section>
        </section>
      </div>
    </vs-popup>
  </div>
</template>

<script>
//Prenvent submit form on every enter on input field
$(window).keydown(function (event) {
  if ($(event.target).prop('nodeName') != 'TEXTAREA') {
    if (event.keyCode == 13) {
      event.preventDefault();
      return false;
    }
  }
});
import Options from "../../../../../public/template/plugins/select2/docs/options.html";

export default {
  components: { Options },
  props: {},
  data() {
    return {
      //question base reply

      can_write: true,
      kpi_incentive_plan_id: 0,
      list_kpi_incentive_plan: [],
      kpi_prize_mode: null,
      thresholds: [],
      organizationalUnits: [],
      showIndicators: [],
      filterSegmentationTypology: [],
      indicators: [],
      externalConditionList: [],
      externalCondition: [],
      limits: [],
      showUnitMeasure: 0,
      showMeasuresAndFormulas: 0,
      showTypology: 0,
      showTarget100: 0,
      showSetConsumptive: 0,
      showTargetMinMax: 0,
      showPrizesMinMax: 0,
      showKpiDescriptionInChart: 0,
      filterByUO: 0,
      defaultUOAssociation: [],
      allStandardSegmentations: [],
      kpiSegmentGroups: [],
      kpi_segment_group_id: null,
      showRal: 0,
      showTargetBonus: 0,
      showTargetEuro: 0,
      can_enable_disable_compilation: 0,
      enable_disable_compilation_message: {},
      languages: {},
      readTarget: 0,
      showPrizeAssigned: 0,
      showPrizeReached: 0,
      enable_segmentation_standard: 0,
      default_segmentation_type: null,
      showPrizeFinal: 0,
      bonusTarget: 0,
      bonusWeight: 0,
      enable_change_target: 0,
      bonusRep: 0,
      grossBonusSumAchieved: 0,
      segmentation_mode: 0,
      segmentation_calculation: -1,
      checkbox_number_goals: 0,
      selected_standard_segmentations: [],
      block_edit_reparted_prize: 0,
      show_all_standard_segmentations: 1,
      show_not_standard_segmentation: 1,
      show_segmentation_info_in_description_modal: 1,
      show_prize_value: 0,
      globalRatingPrize: "avg",
      showPieGraph: 0,
      showLineChart: 0,
      //---
      alertBlockWrongConsumptiveMethodBelowMinGoal: false,
      alertBlockWrongConsumptiveMethodAboveMaxGoal: false,
      messageAlertConsumptiveBelowMinGoal: [],
      messageAlertConsumptiveAboveMaxGoal: [],
      //--- 
      defaultKpiRequireFileOnConsumptive: 'kpi_require_file_on_consumptive_default_false',

      showPercentPerformanceOnCreateKpi: false,
      showPercentReachingOnCreateKpi: false,
      requiredClassificationOnCreateKpi: false,
      showClassificationOnCreateKpi: false,
      showCategoriesOnCreateKpi: false,
      showEsgOnCreateKpi: false,
      showPerformancePercent: 0,
      showReachPercent: 0,
      showSumPercentForWeight: 0,
      showCategories: 0,
      showClassification: 0,
      showEsg: 0,
      showPercentReachForWeight: 0,
      static_goals_array: [],
      segmentations: [],
      segmentation_id: 0,
      approve_kpi: 0,
      segmentation_direction: "increment",
      whoUpdateConsumptive: "owner",
      whoUpdateKpi: "anyone",
      sharedKpiBeneficiaryFilter: 1,
      limitByIndicator: 0,
      title: "Targets",
      active: false,
      action: "",
      name: "",
      description: "",
      sorting: -1,
      editing: true,
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      oldStep: 1,
    }
  },
  methods: {
    rmGoalRow(index) {
      Vue.delete(this.static_goals_array, index);
    },
    addStaticGoal() {
      let row = {
        percentage: 0,
        note: "",
      };
      this.static_goals_array.push(row);
    },

    updateOldStep(stepId) {
      this.oldStep = stepId;
    },
    goToStep(stepId, reloadPage) {

      let formDataSerialized = $("#question12Form").serialize();
      let route = $("#question12Form").attr("action");

      console.log(route);
      axios.put(route,
        {
          questionBase: {

            name: this.name,
            description: this.description,
            sorting: this.sorting
          },
          questionSettings: {
            mboConfig: formDataSerialized,
            oldStep: this.oldStep
          },

        }
      ).then(function (response) {
        //go to next tab
        $("#step-" + stepId).trigger("click");

      }).catch(function (error) {
        console.error("NO", error);
      })
        .finally(function () {

        });
      this.updateOldStep(stepId);
      if (reloadPage) {
        location.reload();
      }
    },

    toggle(action, item_id, editing, attributes) {
      this.active = true;
      this.action = action;
      this.editing = editing;
      let dataRoute = decodeURI(attributes.dataRoute);
      if (dataRoute !== undefined) {
        if (dataRoute.indexOf("[id]") > 0) {
          dataRoute = dataRoute.replace("[id]", item_id);

        }
        axios.get(dataRoute)
          .then((response) => {

            this.name = response.data.base.name;
            this.description = response.data.base.description;
            this.sorting = response.data.base.sorting;
            this.kpi_incentive_plan_id = response.data.kpi_incentive_plan_id;
            this.list_kpi_incentive_plan = response.data.listKPIIncentivePlan;
            this.kpi_prize_mode = response.data.prize_mode;

            this.showUnitMeasure = response.data.show_unit_measure;
            this.showMeasuresAndFormulas = response.data.show_measures_and_formulas;
            this.showTypology = response.data.show_typology;
            this.showTarget100 = response.data.show_target_100;

            this.showTargetMinMax = response.data.show_target_min_max;
            this.showPrizesMinMax = response.data.show_prizes_min_max;
            this.showKpiDescriptionInChart = response.data.show_kpi_description_in_chart;

            this.filterByUO = response.data.filter_by_uo;
            this.defaultUOAssociation = response.data.default_uo_association;
            this.whoUpdateConsumptive = response.data.who_update_consumptive;
            this.whoUpdateKpi = response.data.who_update_kpi;
            this.sharedKpiBeneficiaryFilter = response.data.shared_kpi_beneficiary_filter;
            this.showPrizeAssigned = response.data.show_prize_assigned;
            this.showSumPercentForWeight = response.data.show_sum_percent_reach_for_weight;
            this.showPrizeReached = response.data.show_prize_reached;
            this.showPrizeFinal = response.data.show_prize_final;
            this.showPieGraph = response.data.show_pie_graph;
            this.showLineChart = response.data.show_line_chart;
            this.showPerformancePercent = response.data.show_performance_percent;
            this.showCategories = response.data.show_kpi_categories_in_chart;
            this.showEsg = response.data.show_kpi_esg_in_chart;
            this.showClassification = response.data.show_kpi_classification_in_chart;
            this.showReachPercent = response.data.show_reach_percent;
            this.showPercentReachForWeight = response.data.show_percent_reach_for_weight;
            this.bonusTarget = response.data.show_bonus_target;
            this.bonusWeight = response.data.show_bonus_weight;
            this.bonusRep = response.data.show_bonus_rep;
            this.showRal = response.data.show_ral;
            this.showTargetBonus = response.data.show_target_bonus;
            this.showTargetEuro = response.data.show_target_euro;
            this.readTarget = response.data.read_target;
            this.default_segmentation_type = response.data.default_segmentation_type;
            this.limitByIndicator = response.data.limit_by_indicator;
            this.filterSegmentationTypology = response.data.filter_segmentation_typology;
            this.indicators = response.data.indicators;
            this.limits = response.data.limits;
            this.languages = response.data.languages;
            this.organizationalUnits = response.data.organizationalUnits;
            this.showIndicators = response.data.showIndicators;
            this.externalConditionList = response.data.externalConditionList;
            this.externalCondition = response.data.externalCondition;
            this.enable_change_target = response.data.enable_change_target;
            this.can_enable_disable_compilation = response.data.can_enable_disable_compilation;
            this.enable_disable_compilation_message = response.data.enable_disable_compilation_message;
            this.allStandardSegmentations = response.data.all_standard_segmentations;
            this.segmentation_mode = response.data.segmentation_mode;
            this.segmentation_calculation = response.data.segmentation_calculation;
            this.checkbox_number_goals = response.data.checkbox_number_goals;
            this.show_all_standard_segmentations = response.data.show_all_standard_segmentations;
            this.show_not_standard_segmentation = response.data.show_not_standard_segmentation;
            this.show_segmentation_info_in_description_modal = response.data.show_segmentation_info_in_description_modal;
            this.selected_standard_segmentations = response.data.selected_standard_segmentations;
            this.block_edit_reparted_prize = response.data.block_edit_reparted_prize;
            this.show_prize_value = response.data.show_prize_value;
            this.approve_kpi = response.data.approve_kpi;
            this.enable_segmentation_standard = response.data.enable_segmentation_standard;
            this.static_goals_array = response.data.static_goals_array;
            this.grossBonusSumAchieved = response.data.gross_bonus_sum_achieved;
            this.segmentations = response.data.segmentations;
            this.segmentation_id = response.data.segmentation_id;
            this.segmentation_direction = response.data.segmentation_direction;
            this.globalRatingPrize = response.data.global_rating_prize;
            this.showPercentPerformanceOnCreateKpi = response.data.show_percent_performance_on_create_kpi;
            this.showPercentReachingOnCreateKpi = response.data.show_percent_reaching_on_create_kpi;
            this.requiredClassificationOnCreateKpi = response.data.required_classification_on_create_kpi;
            this.showClassificationOnCreateKpi = response.data.show_classification_on_create_kpi;
            this.showEsgOnCreateKpi = response.data.show_esg_on_create_kpi;
            this.showCategoriesOnCreateKpi = response.data.show_categories_on_create_kpi;
            this.kpiSegmentGroups = response.data.kpi_segment_groups;
            this.kpi_segment_group_id = response.data.kpi_segment_group_id;

            this.alertBlockWrongConsumptiveMethodBelowMinGoal = response.data.alert_block_wrong_consumptive_method_below_min_goal;
            this.alertBlockWrongConsumptiveMethodAboveMaxGoal = response.data.alert_block_wrong_consumptive_method_above_max_goal;
            this.messageAlertConsumptiveBelowMinGoal = response.data.message_consumptive_below_min_goal;
            this.messageAlertConsumptiveAboveMaxGoal = response.data.message_consumptive_above_max_goal;

            this.defaultKpiRequireFileOnConsumptive = response.data.kpi_require_file_on_consumptive;

            this.can_write = 1;
          });
      }
    }

  }

}
</script>
